import { createStyles, makeStyles } from '@hawkins/styles';
export function menuStyles(theme) {
    var _a;
    var hawkins = theme.hawkins, hawkinsUtils = theme.hawkinsUtils, hawkinsVariables = theme.hawkinsVariables;
    var borderRadius = hawkinsVariables.borderRadius.borderRadius0;
    return createStyles({
        /** Class name of the `FloatingUI`. */
        floatingUI: {
            zIndex: hawkinsVariables.zIndexes.dropdown,
        },
        /** Class name of the root element. */
        root: (_a = {
                backgroundColor: hawkins.elevation.backgroundColor2,
                borderColor: hawkins.elevation.borderColorElevated,
                borderRadius: borderRadius,
                borderStyle: 'solid',
                borderWidth: hawkins.elevation.borderWidthElevated,
                boxShadow: hawkins.elevation.boxShadow2,
                margin: 0,
                padding: hawkinsVariables.spacingValues.space0 / 2
            },
            _a[[
                // Account for the fact that menu items can be nested inside menu groups.
                hawkinsUtils.getMenuItemSelector('& > '),
                hawkinsUtils.getMenuItemSelector('& > *:first-child > '),
            ].join(', ')] = {
                '&:first-child': {
                    borderTopLeftRadius: borderRadius,
                    borderTopRightRadius: borderRadius,
                },
            },
            _a[[
                // Account for the fact that menu items can be nested inside menu groups.
                hawkinsUtils.getMenuItemSelector('& > '),
                hawkinsUtils.getMenuItemSelector('& > *:last-child > '),
            ].join(', ')] = {
                '&:last-child': {
                    borderBottomLeftRadius: borderRadius,
                    borderBottomRightRadius: borderRadius,
                },
            },
            _a),
        /** Class name of the element containing the trigger. */
        triggerContainer: {
            display: 'inline-block',
        },
        /** Class name of the trigger container when it is a block-level element. */
        triggerContainerBlock: {
            display: 'block',
        },
    });
}
export var useMenuStyles = makeStyles(menuStyles, { name: 'Hawkins-Menu' });
